import * as React from 'react';
const XerosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m106.26 91.29 5.4-6.3 5.4 1.8v4.5l2.7 3.6-1.8 5.39-6.3-2.7-4.5.9.9-3.59zM96.37 102.98l7.2-.9 3.59-3.6M106.26 91.29l-4.49-3.6h-1.8l-4.5 3.6-3.6 5.39M99.97 87.69l-1.8-2.7 4.5-3.6 8.09.9.9 2.7M112.56 68.8l-3.6 6.3 1.8 7.19"
      className="prefix__cls-1"
    />
    <path
      d="m117.06 86.79 2.7-2.7.9-2.7-.9-2.7-.9-8.09M102.67 81.39l-.9-4.5 7.19-1.79"
      className="prefix__cls-1"
    />
    <path
      d="m89.17 87.69 9-2.7-2.7-5.4.9-3.59 5.4.89M126.95 79.59l-2.69 1.8h-3.6M119.76 94.89l8.99-7.2M117.96 100.28l3.6 2.7M103.57 102.08l.9 4.5M96.37 76l-.9-2.7"
      className="prefix__cls-1"
    />
    <circle cx={108.96} cy={87.69} r={19.79} className="prefix__cls-1" />
    <path
      d="M95.47 63.11c-2.23-7.08-4.33-11.38-4.33-11.38M68.6 58.24s-.16 22.16 9.42 36.77c9.57 14.61 13.49 20.23 10.26 26.47-3.24 6.24-4.98 13.61 1.62 14.99 6.6 1.37 10.46-.37 16.43 6.37s12.82 5.74 19.29 4.62 7.47-6.87 3.24-9.12-6.9.28-12.2-8.12c-5.44-8.62-5.53-8.96-7.69-13.91"
      className="prefix__cls-2"
    />
  </svg>
);
export default XerosiIcon;
